import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async requestsUpgradeProject(context, data) {
      try {
        const response = await axios.post('/projects-administration/cfa-upgrade-requests', data, { withCredentials: true });
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async getRequestsUpgradeProjectByProjectId(context, projectId) {
      try {
        const response = await axios.get(`/projects-administration/cfa-upgrade-requests/${projectId}`, { withCredentials: true });
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async startUpgradeProject(context, id) {
      try {
        const response = await axios.get(`/projects-administration/cfa-upgrade-requests/${id}/start`, { withCredentials: true });
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async finishUpgradeProject(context, id) {
      try {
        const response = await axios.get(`/projects-administration/cfa-upgrade-requests/${id}/finish`, { withCredentials: true });
        return response.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
